const USER_PASSWORD_MIN_LENGTH = 8;
const UserPassword = {
  Min: {
    value: USER_PASSWORD_MIN_LENGTH,
    message: `La contraseña no puede ser menor a ${USER_PASSWORD_MIN_LENGTH} caracteres`,
  },
};

export const UserValidations = {
  UserPassword: UserPassword,
};
